import React from "react";
import { FiCheck } from "react-icons/fi";
import "./VcListView.scss";

const VcListView = ({ vcs, theme, toggleVcSelection, selectedVcs }) => {
  if (!vcs || vcs.length === 0) {
    return (
      <div className="noVcs">
        <p>No VCs in this list yet.</p>
      </div>
    );
  }

  return (
    <div className={`vcListView ${theme}`}>
      {vcs.map((vc) => (
        <div 
          key={vc._id} 
          className={`vcCard ${selectedVcs.includes(vc._id) ? 'selected' : ''}`}
        >
          <div className="vcInfo">
            <div className="vcAvatar">
              {vc.logo ? (
                <img src={vc.logo} alt={vc.name} />
              ) : (
                <div className="avatarPlaceholder">
                  {vc.name?.charAt(0) || ''}
                </div>
              )}
            </div>
            <div className="vcDetails">
              <h3>{vc.name} <span className="vcType">VC</span></h3>
              <p className="vcEmail">{vc.email || 'Email not specified'}</p>
              <p className="vcLocation">{vc.location || 'Location not specified'}</p>
            </div>
          </div>
          <div className="vcActions">
            <button 
              className={`selectButton ${selectedVcs.includes(vc._id) ? 'selected' : ''}`}
              onClick={() => toggleVcSelection(vc._id)}
            >
              {selectedVcs.includes(vc._id) ? (
                <>
                  <FiCheck /> Selected
                </>
              ) : (
                'Select'
              )}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VcListView; 